
    var riot = require('riot')
    //src: starling/src/tags/modal-share.html
riot.tag2('modal-share',
  '<div class="Modal Modal--locked Modal--tall modal-share" onmousedown="{handleModalClick}" onclick="{stopPropagation}"> <header class="Modal_header"> <h2 class="Modal_title Modal_title--small"> Share <strong class="modal-share_map-title">{getTitle()}</strong> with others </h2> <button class="Modal_close" onclick="{dismiss}"> <svg class="Modal_close_icon"> <use xlink:href="#close-icon"></use> </svg> </button> </header> <ul class="modal-share_tabs"> <li if="{hasEditAccess()}" ref="tab" data-tab="share-access" class="modal-share_tab {openTab === \'share-access\' && \'modal-share_tab--active\'}" onclick="{handleTabClick}"> Invite collaborators <span if="{collaboratorsPending && collaboratorsPending.length}" class="modal-share_tab_badge"> {collaboratorsPending.length} </span> </li> <li ref="tab" data-tab="share-url" class="modal-share_tab {openTab === \'share-url\' && \'modal-share_tab--active\'}" onclick="{handleTabClick}"> Get shareable link </li> <li ref="tab" data-tab="share-presentation" class="modal-share_tab {openTab === \'share-presentation\' && \'modal-share_tab--active\'}" onclick="{handleTabClick}"> Share presentation </li> <li ref="tab" data-tab="embed-map" class="modal-share_tab {openTab === \'embed-map\' && \'modal-share_tab--active\'}" onclick="{handleTabClick}"> Embed this map </li> </ul> <div class="Modal_body"> <panel-invite if="{hasEditAccess()}" show="{openTab === \'share-access\'}" canvas="{canvas}"></panel-invite> <panel-link show="{openTab === \'share-url\'}" canvas="{canvas}"></panel-link> <panel-presentation show="{openTab === \'share-presentation\'}" canvas="{canvas}"></panel-presentation> <panel-embed show="{openTab === \'embed-map\'}" canvas="{canvas}"></panel-embed> </div> <footer class="Modal_footer"> <button class="Button Button--Primary Button--Small" onclick="{saveAndDismiss}">Done</button> </footer> </div>',
  '',
  'class="Modal_overlay" show="{isVisible}" onclick="{dismiss}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _util = require('lib/util');

var _opts = opts,
    canvas = _opts.canvas,
    operation = _opts.operation,
    store = _opts.store;

canvas.shareModal = this;

this.canvas = canvas;
this.colorFromUserId = _util.colorFromUserId;
this.collaboratorsPending = [];

this.setDefaultTab = function () {
  if (_this.hasEditAccess()) {
    _this.openTab = 'share-access';
  } else {
    _this.openTab = 'share-url';
  }
};

this.hasEditAccess = function () {
  return store.access.permission === 'edit';
};

this.show = function () {
  _this.isVisible = true;
  _this.setDefaultTab();
  _this.setOpenTab(_this.openTab);
  _this.update();
  canvas.searchModal.dismiss();
  _this.retrievePendingAccessRequests();
};

this.retrievePendingAccessRequests = function () {
  // TODO: is there a better way of doing this?
  $.get('/api/maps/' + window.access.publicIdentifier + '/get-pending-access-requests').then(function (_ref) {
    var collaboratorsPending = _ref.users;

    _this.update({ collaboratorsPending: collaboratorsPending });
    _this.tags['panel-invite'].update({ collaboratorsPending: collaboratorsPending });
  });
};

this.dismiss = function (e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  _this.isVisible = false;

  canvas.editShareUserAccessMenu.hide();
  canvas.acceptRequestAccessMenu.hide();

  var inviteSharePanel = canvas.inviteSharePanel,
      autocompleteContactsTag = canvas.autocompleteContactsTag;

  if (inviteSharePanel) {
    inviteSharePanel.clearInput();
  }

  if (autocompleteContactsTag) {
    autocompleteContactsTag.hide();
  }

  _this.update();
};

this.isOpen = function () {
  return _this.isVisible;
};

this.handleTabClick = function (e) {
  _this.setOpenTab(e.target.dataset.tab);
};

this.setOpenTab = function (tab) {
  _this.openTab = tab;
  canvas.editShareUserAccessMenu.hide();
  canvas.acceptRequestAccessMenu.hide();
  _this.update();
};

this.saveAndDismiss = function (e) {
  if (_this.openTab === 'share-access') {
    var inviteSharePanel = canvas.inviteSharePanel;

    if (inviteSharePanel.refs.shareAccessEmailInput.value.trim().length) {
      inviteSharePanel.saveShareAccessInputs();
    }
  }

  _this.dismiss(e);
};

this.handleModalClick = function (e) {
  var autocompleteContactsTag = canvas.autocompleteContactsTag;

  if (canvas.editShareUserAccessMenu.isOpen) {
    canvas.editShareUserAccessMenu.hide();
  }

  if (canvas.acceptRequestAccessMenu.isOpen) {
    canvas.acceptRequestAccessMenu.hide();
  }

  if (autocompleteContactsTag) {
    autocompleteContactsTag.hide();
  }
};

this.stopPropagation = function (e) {
  e.stopPropagation();
};

this.getTitle = function () {
  return (0, _util.decodeHtml)(store.getTitle());
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-share')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-share.html
// module id = 624
// module chunks = 0